import { createContext } from 'react'

export type AuthorizationContextValue = {
  loading?: boolean
  refetch?: () => void
  isAdmin?: boolean
}

export const AuthorizationContext = createContext<AuthorizationContextValue>({})
